var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", _vm._l(_vm.dataList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "list",
      style: {
        height: _vm.height
      }
    }, [_c("div", {
      staticClass: "first-column"
    }, [_vm._v(_vm._s(item.first))]), _c("div", {
      staticClass: "other-column"
    }, [_vm._v(_vm._s(item.second))]), _c("div", {
      staticClass: "other-column"
    }, [_vm._v(_vm._s(item.third))]), _c("div", {
      staticClass: "last-column"
    }, [_c("div", {
      staticClass: "list-block",
      style: _vm.isImg(item)
    }, [_c("img", {
      attrs: {
        src: item.last.img,
        alt: ""
      }
    }), _c("div", {
      staticClass: "list-block-text"
    }, [_vm._v(" " + _vm._s(item.last.text) + " ")])])])]);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };